export default __webpack_public_path__ + "static/media/help.95f924ac.svg";